import React, {useEffect, useState, useRef} from "react";
import {Paragraph, PageHeader} from "BaseComponents/Text/";
import {useSelector, useDispatch} from "react-redux";
import propTypes from "prop-types";
import {SearchAnimations} from "Animations";
import {searchActions} from "Framework/redux/actions/index";
import {SearchHit} from "./hits/SearchHit";
import {
    HitsWrapper,
    SearchTopWrapper,
    SearchTop,
    InnerWrapper,
    DropdownLabel,
    NoHitsTextParagraph,
} from "./hits/StyledSearch";
import {PrimaryButton, ButtonText} from "BaseComponents/Button";
import {
    SearchButton,
    InputWrapper,
    Input,
    Icon,
} from "../SearchField/StyledSearchFieldComponents";
import {Dropdown} from "../Dropdown/Dropdown";

export const Search = ({
                           Heading,
                           SearchHits,
                           TotalHits,
                           IsMixedContent,
                           FilterCategoryName,
                           FilterSearchName,
                           ShowAllText,
                           LoadMore,
                           SearchQuery: {
                               CurrentCulture,
                               CurrentPageId,
                               DocumentTypes,
                               IsFallbackText,
                               FallbackSearchText,
                               NoHitsText,
                               Query,
                               Skip,
                               StartPageId,
                               Take,
                               SearchHitsText,
                               TakeNrFromPage,
                               Categories,
                               OrderByDate = true
                           },
                       }) => {
    const state = useSelector((state) => state.search);
    const [loading, setLoading] = useState(useSelector((state) => state.loading));
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [take, setTake] = useState(Take);
    const [skip, setSkip] = useState(Skip);
    const [initialTake, setInitialTake] = useState(Take);
    const [searchHitsText, setSearchHitsText] = useState(
        useSelector((state) => state.searchHitsText)
    );
    const [initialSearch, setInitialSearch] = useState(true);
    const [initialSearchCategory, setInitialSearchCategory] = useState(true);
    const [searchQuery, setSearchQuery] = useState(
        useSelector((state) => state.query)
    );
    const [searchHits, setSearchHits] = useState(
        useSelector((state) => state.items)
    );
    const [filteredHits, setFilteredHits] = useState([]);
    const [hitCount, setHitCount] = useState(
        useSelector((state) => state.TotalCount)
    );
    const [isMixedContent, setIsMixedContent] = useState(
        useSelector((state) => state.isMixedContent)
    );
    const dispatch = useDispatch();
    const inputEl = useRef(null);

    useEffect(() => {
        let cats = [];
        Categories.map((cat, i) => {
            cats.push({value: cat, label: cat});
        });
        cats.length === 1 && setSelectedCategory(cats[0]);
        setCategories(cats);
    }, []);

    useEffect(() => {
        if (initialSearchCategory) {
            setInitialSearchCategory(false);
        } else {
            Get(false, true);
        }
    }, [selectedCategory]);

    let itemsToShow = SearchHits;
    // initialSearch && selectedCategory == ""
    //     ? SearchHits
    //     : selectedCategory != ""
    //         ? filteredHits
    //         : searchHits;
    const onDropdownChange = (selected) => {
        setSkip(Skip);
        if (selected != null) {
            setSelectedCategory({value: selected.value, label: selected.label});
        } else {
            setSelectedCategory(undefined);
        }
        setTake(Take);
    };

    const filterHits = () => {
        //let hits = state.items;
        // if (selectedCategory.label != undefined) {
        //     setInitialSearch(false);
        //     hits = hits.filter((hit, i) => {
        //         return (
        //             hit.Category?.toLowerCase() === selectedCategory.value.toLowerCase()
        //         );
        //     });
        //     setHitCount(hits.length);
        //     setLoading(false);
        //     setFilteredHits(hits);
        // } else {
        setFilteredHits([]);
        setSearchHits(state.items);
        setHitCount(state.TotalCount);
        //}
    };
    useEffect(() => {
        filterHits();
        setLoading(false);
        setIsMixedContent(state.isMixedContent);
        setSearchHitsText(state.searchHitsText);
    }, [state.items]);
    const FocusInput = (e) => {
        e.preventDefault();
        inputEl.current.focus();
    };
    useEffect(() => {
        Get(true);
        inputEl.current.value = Query;
    }, []);

    useEffect(() => {
        if (initialSearch) {
            setInitialSearch(false);
        } else {
            Get(false, true);
        }
    }, [searchQuery]);

    useEffect(() => {
        if (initialSearch) {
            setInitialSearch(false);
        } else {
            GetMore();
        }
    }, [take]);
    const Get = (initial, force = false) => {
        if (force ||
            (searchQuery !== undefined && searchQuery.length > 0) ||
            initialSearch
        ) {
            setLoading(true);
            dispatch(
                searchActions.get(
                    initial ? SearchHits : searchHits,
                    initial ? Query : searchQuery !== undefined ? searchQuery : Query,
                    initial || searchQuery !== undefined ? Take : take,
                    initial || searchQuery !== undefined ? Skip : skip,
                    initial ? SearchHitsText : searchHitsText,
                    CurrentCulture,
                    DocumentTypes,
                    StartPageId,
                    CurrentPageId,
                    TakeNrFromPage,
                    initialSearch,
                    TotalHits,
                    initial ? IsMixedContent : isMixedContent,
                    OrderByDate,
                    initial ? Categories : selectedCategory && selectedCategory?.length !== 0 ? [selectedCategory.value] : Categories,
                    undefined,
                    true
                )
            );
        }
    };
    const GetMore = () => {
        setLoading(true);
        dispatch(
            searchActions.more(
                searchHits,
                searchQuery !== undefined ? searchQuery : Query,
                searchQuery !== undefined ? searchHits.length + initialTake : take,
                searchQuery !== undefined ? searchHits.length : skip,
                searchHitsText,
                CurrentCulture,
                DocumentTypes,
                StartPageId,
                CurrentPageId,
                TakeNrFromPage,
                initialSearch,
                initialSearch ? IsMixedContent : isMixedContent,
                OrderByDate,
                !selectedCategory || selectedCategory?.length === 0 ? Categories : [selectedCategory.value],
            )
        );
    };
    const HandleClick = () => {
        if (inputEl.current.value !== searchQuery) {
            // setSelectedCategory("");
            setSearchQuery(inputEl.current.value);
        }
    };

    const HandleEnterClick = (e) => {
        if (e.key === "Enter") {
            HandleClick();
        }
    };
    // const getSearchTextString = () => {
    //     let text =
    //         searchHits?.length > 0
    //             ? `Visar <b> ${searchHits.length} </b>av <b>${state.TotalCount}</b> 
    // ${state.query != "" ? `på "${state.query}"` : "träffar"}`
    //             : "";
    //     return text;
    // };
    console.log('FilterSearchName', FilterSearchName);
    return (
        <>
            <SearchTopWrapper>
                {Heading && <PageHeader Heading={Heading} margin="0 0 15px 0"/>}
                <SearchTop>
                    <InnerWrapper>
                        <DropdownLabel>{FilterCategoryName}</DropdownLabel>
                        <Dropdown
                            placeHolderText={ShowAllText}
                            {...{categories, selectedCategory}}
                            handleChange={(selectedCategory) =>
                                onDropdownChange(selectedCategory)
                            }
                        />
                    </InnerWrapper>
                    <InnerWrapper>
                        <DropdownLabel>{FilterSearchName}</DropdownLabel>
                        <InputWrapper onClick={(e) => FocusInput(e)}>
                            <SearchButton
                                disabled={IsFallbackText}
                                onClick={(e) => HandleClick()}
                            >
                                <Icon className="icon-search"></Icon>
                            </SearchButton>
                            <Input
                                ref={inputEl}
                                placeholder={FilterSearchName}
                                onKeyDown={(e) => HandleEnterClick(e)}
                                disabled={IsFallbackText}
                            />
                        </InputWrapper>
                    </InnerWrapper>
                </SearchTop>
                <Paragraph
                    large
                    dangerouslySetInnerHTML={{
                        __html: searchHitsText,
                    }}
                ></Paragraph>
                {IsFallbackText && (
                    <Paragraph
                        large
                        bold
                        display="block"
                        margin="1rem 0 0 0"
                        dangerouslySetInnerHTML={{__html: FallbackSearchText}}
                    ></Paragraph>
                )}
            </SearchTopWrapper>
            <HitsWrapper>
                {(searchHits !== undefined) && (
                    <SearchAnimations
                        items={searchHits}
                        isMixedContent={isMixedContent}
                        search
                        loading={loading}
                        mass={15}
                        tension={2000}
                        friction={200}
                    >
                        <SearchHit isMixedContent={isMixedContent}/>
                    </SearchAnimations>
                )}
                {/* {searchHits !== undefined && searchHits.map((hit, i) => <p>{hit.Heading}</p>)} */}
                {!loading && hitCount == 0 && (
                    <NoHitsTextParagraph>{NoHitsText}</NoHitsTextParagraph>
                )}
            </HitsWrapper>
            {searchHits != undefined && hitCount > searchHits.length && (
                <PrimaryButton
                    justifycontent="center"
                    display="flex"
                    margin="0 auto 3rem auto"
                    onClick={() => {
                        setTake(take + initialTake);
                        setSkip(skip + initialTake);
                    }}
                >
                    <ButtonText>{LoadMore}</ButtonText>
                </PrimaryButton>
            )}
        </>
    );
};

Search.propTypes = {
    Heading: propTypes.string,
};
